import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Button, Card, Flex, Space } from "antd";

import { MainLayout } from "components/layouts";
import styles from "../styles/CompanyProfile.module.css";

import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import CompanyConfigMailFilter from "./CompanyConfigMailFilter";

const CompanyConfigMail = ({
  onSearch = () => { },
  onEdit = () => { },
  onDelete = () => { },
  onView = () => { },
  onAddNew = () => { },
  onChange = () => { },
  onCancel = () => { },
  onTestConnent = () => { },
  onsubmitModal = () => { },
  isLoadingData = false,
  isLoading = false,
  configMailList = [],
  showModal,
  rowIndex,
  type,
  testConnect = true,
  commonTypeByGroupType = []

}) => {
  const { t } = useTranslation();
  const [useFilter, setUseFilter] = useState(false);


  return (
    <MainLayout>
      <Space className={styles.container} direction="vertical" size={24}>
        <Flex justify="space-between" align="center">
          <Flex vertical>
            <Breadcrumb items={[
              { title: t("home.header"), href: "/" },
              { title: t("masterdata.header"), href: "" },
              { title: t("companyConfigMail.companyConfigMail"), link: "/configuration/company" },
            ]} />
            <h2>{t("companyConfigMail.companyConfigMail")}</h2>
          </Flex>
          <Flex gap={10}>
            <Button
              style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}
              type="primary"
              onClick={() => onAddNew()}
            >
              <Flex align="center" justify="center" gap={8}>
                <CreateIcon />
                <span>{t('companyConfigMail.addMail')}</span>
              </Flex>
            </Button>
          </Flex>
        </Flex>
        <Flex vertical style={{ rowGap: 16 }}>
          <Flex justify="end">
            <Button
              type="default"
              onClick={() => setUseFilter(!useFilter)}
              style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
              <Flex align="center" justify="center" gap={8}>
                <FilterIcon />
                <span style={{ color: "#667085" }}>{t('common.filter')}</span>
              </Flex>
            </Button>
          </Flex>
        </Flex>

        <Card style={{
          borderRadius: "8px",
          backgroundColor: "white",
          border: "1px solid #EAECF0",
          height: "100%",
        }}>
          <CompanyConfigMailFilter
            useFilter={useFilter}
            onSearch={onSearch}
            onEdit={onEdit}
            onDelete={onDelete}
            onView={onView}
            onChange={onChange}
            onCancel={onCancel}
            onTestConnent={onTestConnent}
            onSubmit={onsubmitModal}
            isLoadingData={isLoadingData}
            isLoading={isLoading}
            configMailList={configMailList}
            showModal={showModal}
            rowIndex={rowIndex}
            type={type}
            testConnect={testConnect}
            commonTypeByGroupType={commonTypeByGroupType}
          />
        </Card>

      </Space>
    </MainLayout>
  );
};

export default CompanyConfigMail;
